import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useCallback, useState } from 'react';
import { ModalComponent } from '../Modal/modal';
import { Button } from '../button/button';
import { modalSubmit } from '../../actions/ui';
import { useDispatch } from 'react-redux';
const defaultForceSubmitOptions = {
    isForced: false,
    time: 60,
    message: 'Submitting Automatically in '
};
export const LogoutModal = ({ buttonText, children, footerChildren, handler, icon, modalParams, title, closable = true, forceSubmitOptions = defaultForceSubmitOptions, ...rest })=>{
    const dispatch = useDispatch();
    const [modalState, setModalState] = useState({
        timeLeft: forceSubmitOptions?.time ?? 60,
        countdownSet: null
    });
    const [isModalOpen, setIsModalOpen] = useState(true);
    useEffect(()=>{
        let myInterval = setInterval(()=>{
            if (forceSubmitOptions?.isForced && modalState.timeLeft <= 0) {
                const event = new CustomEvent('');
                handler && _handleClick(event);
            } else if (forceSubmitOptions?.isForced && modalState.timeLeft > 0 && modalState.countdownSet === null) {
                setModalState({
                    ...modalState,
                    timeLeft: modalState.timeLeft - 1
                });
            }
        }, 1000);
        return ()=>{
            clearInterval(myInterval);
        };
    });
    const _handleClick = async (event)=>{
        event.preventDefault();
        if (handler) {
            dispatch(modalSubmit({
                name: handler,
                params: modalParams
            }));
        }
    };
    const forcedSubmitMessage = forceSubmitOptions && forceSubmitOptions?.message + modalState.timeLeft;
    const handleUnload = useCallback((event)=>{
        if (handler) {
            dispatch(modalSubmit({
                name: handler,
                params: modalParams
            }));
        }
    }, [
        handler,
        dispatch,
        modalParams
    ]);
    useEffect(()=>{
        window.addEventListener('unload', handleUnload);
        window.addEventListener('popstate', handleUnload);
        return ()=>{
            window.removeEventListener('unload', handleUnload);
            window.removeEventListener('popstate', handleUnload);
        };
    }, [
        handleUnload
    ]);
    return /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'lg',
        isOpen: isModalOpen,
        handleClose: ()=>{
            setIsModalOpen(false);
        },
        showCloseIcon: closable,
        modalHeader: /*#__PURE__*/ _jsxs("div", {
            children: [
                icon && /*#__PURE__*/ _jsx("span", {
                    children: icon
                }),
                title && /*#__PURE__*/ _jsx("div", {
                    children: title
                })
            ]
        }),
        modalContent: /*#__PURE__*/ _jsx("div", {
            children: forceSubmitOptions?.isForced ? forcedSubmitMessage : children
        }),
        modalFooter: /*#__PURE__*/ _jsxs("div", {
            onClick: _handleClick,
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    dataTestId: "submitButton",
                    label: buttonText ?? ''
                }),
                ' ',
                footerChildren && /*#__PURE__*/ _jsxs("div", {
                    children: [
                        footerChildren,
                        " "
                    ]
                })
            ]
        })
    });
};
